import React, { useState, useEffect } from "react";
import { Field, Form, FormSpy } from "react-final-form";
import { connect } from "react-redux";
import { required } from "redux-form-validators";
import Wysiwyg from "../../../Components/Forms/wysiwyg";
import NDTRCTags from "../../../Components/Forms/ndtrctags";
import FooterForm from "../../../Components/Lib/FooterForm";
import Autosuggest from "../../../Components/Forms/autocomplete";
import SwitchButton from "../../../Components/Forms/switch";
import AITextField from "../Components/AITextField";
import AIWysiwyg from "../Components/AIWysiwyg";
import {
  renderTextField,
  renderField,
  renderAField,
  renderselectsimple,
  renderAFieldDisabled
} from "../../../Components/Forms/renders";

const SyncValidationForm = ({ onSubmit, item, user }) => {
  const [isEvent, setIsEvent] = useState(false);
  const isLocatiebeheerder = user?.role === 'locatiebeheerder';

  const handleEntityTypeChange = (value) => {
    setIsEvent(value.target.value === "EVENEMENT");
  };

  useEffect(() => {
    if (item.metadata.entitytype === "EVENEMENT") {
      setIsEvent(true);
    }
  }, [item.metadata.entitytype]);

  const renderEventFields = () => {
    if (isEvent) {
      return (
        <div>
          {!isLocatiebeheerder && (
            <Field
              name="subitemsgroup"
              type="input"
              component={Autosuggest}
              label="Kies om het item aan een locatie te koppelen"
            />
          )}
          <Field
            name="event.everyyear"
            type="input"
            component={SwitchButton}
            label="Wordt dit evenement jaarlijks herhaald?"
          />
        </div>
      );
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={item}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <div className="col-sm-12">
            <h4 className="info-text">Vul hier de algemene gegevens in</h4>
          </div>
          <Field
            className="form"
            autoFocus
            name="metadata.entitytype"
            validate={required({ msg: "Type item is verplicht" })}
            label="Maak eerst een keuze"
            component={renderselectsimple}
            options={{
              EVENEMENT: "Evenement",
              LOCATIE: "Locatie"
            }}
            onChange={handleEntityTypeChange}
          />
          {renderEventFields()}

          <Field
            name="what.title.value"
            validate={required({ msg: "Titel is verplicht" })}
            type="text"
            component={renderField}
            label="Titel"
          />
          <Field
            name="what.slug.value"
            type="text"
            component={renderAFieldDisabled}
            label="Slug van de titel"
          />
          <Field
            name="what.shortdescription.value"
            validate={required({ msg: "Beschrijving is verplicht" })}
            component={AITextField}
            label="Korte Omschrijving"
            trcid={item.metadata.trcid}
            fieldType="korte_beschrijving"
          />
          <Field
            name="what.longdescription.value"
            type="textarea"
            component={AIWysiwyg}
            label="Lange Omschrijving"
            className="form-control"
            trcid={item.metadata.trcid}
            fieldType="lange_beschrijving"
            normalize={(value) => value.toString("html")}
          />
          {!isLocatiebeheerder && (
            <Field
              name="types"
              validate={!isLocatiebeheerder ? required({ msg: "Types zijn verplicht" }) : undefined}
              type="text"
              component={NDTRCTags}
              label="Tags"
              className="form-control"
            />
          )}
          <FormSpy subscription={{ values: true }}>
            {({ values }) => {
              // Check if type 3.1.6 is selected in the types array
              const hasType316 = values.types && Array.isArray(values.types) &&
                values.types.some(type => type.catid === "3.1.6");

              if (hasType316) {
                return (
                  <Field
                    name="what.wild.value"
                    type="textarea"
                    component={Wysiwyg}
                    label="Wild beschrijving"
                    className="form-control"
                    normalize={(value) => value.toString("html")}
                  />
                );
              }
              return null;
            }}
          </FormSpy>
          <FooterForm />
        </form>
      )}
    />
  );
};

// Connect to Redux store
const mapStateToProps = (state) => ({
  item: state.items.item,
  user: state.auth.user
});

export default connect(mapStateToProps)(SyncValidationForm);